// src/lang/index.js
// *******************************************************************************
// 1. IMPORTS
// *******************************************************************************
import PtBRLang from './entries/pt_BR';
import EnUSLang from './entries/en_US';

import pt from './locales/pt_BR.json';
import ptPT from './locales/pt_PT.json';
import en from './locales/en_US.json';
import esES from './locales/es_ES.json';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import app from 'configs/appResolver';

// *******************************************************************************
// 2. HELPERS
// *******************************************************************************
const COUNTRY_TO_LOCALE = {
  br: 'pt-br',
  pt: 'pt-pt',
  us: 'en-us',
  gb: 'en-gb',
  uk: 'en-gb',
  ca: 'en-ca',
  au: 'en-au',
  nz: 'en-nz',
  in: 'en-in',
  de: 'de-de',
  fr: 'fr-fr',
  es: 'es-es',
  mx: 'es-mx',
  ar: 'es-ar',
  cl: 'es-cl',
  it: 'it-it',
  jp: 'ja-jp',
  cn: 'zh-cn',
  tw: 'zh-tw',
};

export const resolveI18nKey = val => {
  const v = (val || '').toString().toLowerCase().replace('_', '-');

  // direct country code -> maps to 2+2 locale with hyphen
  if (COUNTRY_TO_LOCALE[v]) return COUNTRY_TO_LOCALE[v];

  // known locale formats
  if (v === 'pt-pt') return 'pt-pt';
  if (v.startsWith('pt')) return 'pt-br';
  if (v.startsWith('en')) return 'en-us';
  if (v.startsWith('zh')) return 'zh';
  if (v.startsWith('fr')) return 'fr';
  if (v.startsWith('ja')) return 'ja';
  if (v === 'es-es' || v === 'es' || v.startsWith('es')) return 'es-es';

  return 'en-us';
};

// *******************************************************************************
// 3. RESOURCES (translations + antd locale)
// *******************************************************************************
export const resources = {
  'pt-br': { translation: pt, antd: PtBRLang.antd },
  'pt-BR': { translation: pt, antd: PtBRLang.antd },
  pt: { translation: pt, antd: PtBRLang.antd },
  'pt-pt': { translation: ptPT, antd: PtBRLang.antd },
  'pt-PT': { translation: ptPT, antd: PtBRLang.antd },

  'en-us': { translation: en, antd: EnUSLang.antd },
  'en-US': { translation: en, antd: EnUSLang.antd },
  en: { translation: en, antd: EnUSLang.antd },

  'es-es': { translation: esES, antd: EnUSLang.antd },
  'es-ES': { translation: esES, antd: EnUSLang.antd },
  es: { translation: esES, antd: EnUSLang.antd },
};

// *******************************************************************************
// 4. I18N INIT
// *******************************************************************************
const savedLng = typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null;
const initial = savedLng || resolveI18nKey(app?.LANGUAGE || 'en-us');

if (!savedLng && typeof window !== 'undefined') {
  localStorage.setItem('i18nextLng', initial);
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: initial,
  lng: initial,
  interpolation: { escapeValue: false },
  // Suppress all i18next promotional/informational console output.
  // The Locize promo message bypasses logLevel by calling console.info directly,
  // so we override the logger entirely to only forward warnings and errors.
  logger: {
    warn: (...args) => console.warn('[i18n]', ...args),
    error: (...args) => console.error('[i18n]', ...args),
    log: () => {},
  },
});

export default i18n;
